export function splitAtLastWord(str: string): [string, string] {
    const trimmed = str.trim();
    
    if (!trimmed) {
        return ["", ""];
    }
    
    const lastSpaceIndex = trimmed.lastIndexOf(" ");
    
    if (lastSpaceIndex === -1) {
        return ["", trimmed];
    }
    
    return [trimmed.substring(0, lastSpaceIndex).trim(), trimmed.substring(lastSpaceIndex + 1)];
}
